import styled from "@emotion/styled";

export const EventFormFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 0.5rem;
`;
